/**
 * Pile Info Injector
 * This script monitors the Price Calculator app's field group and injects an informational message
 * for "Pile Şekilleri" and "Pile Sıklığı".
 */

// Define global functions for the drawers
function createDrawerFunctions(drawerId) {
    return {
        open: function() {
            const drawer = document.getElementById(drawerId);
            if (drawer) {
                drawer.removeAttribute('hidden');
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        drawer.setAttribute('active', '');
                        document.body.classList.add('etulle-drawer-open');
                    });
                });
                document.body.style.overflow = 'hidden';
            }
        },
        close: function() {
            const drawer = document.getElementById(drawerId);
            if (drawer) {
                drawer.removeAttribute('active');
                document.body.classList.remove('etulle-drawer-open');
                setTimeout(() => {
                    if (!drawer.hasAttribute('active')) {
                        drawer.setAttribute('hidden', '');
                    }
                }, 400);
                document.body.style.overflow = '';
            }
        }
    };
}

const pileDrawerFuncs = createDrawerFunctions('EtullePileInfoDrawer');
window.openPileDrawer = pileDrawerFuncs.open;
window.closePileDrawer = pileDrawerFuncs.close;

const pileSikligiDrawerFuncs = createDrawerFunctions('EtullePileSikligiDrawer');
window.openPileSikligiDrawer = pileSikligiDrawerFuncs.open;
window.closePileSikligiDrawer = pileSikligiDrawerFuncs.close;

(function() {
    const configs = [
        {
            selectors: ['.pile_ekli'],
            infoDivClass: 'pile-info-message-injected',
            text: 'Farklı pile çeşitleri hakkında bilgi almak için tıklayın',
            openDrawerFn: window.openPileDrawer
        },
        {
            selectors: ['.pile_skl', '.pile_skl_kanun', '.pile_skl_amerikan', '.pile_skl_spile', '.montaj_ekli_1rustik'],
            infoDivClass: 'pile-sikligi-message-injected',
            text: 'Pile sıklıkları hakkında bilgi almak için tıklayın',
            openDrawerFn: window.openPileSikligiDrawer
        }
    ];

    function updateInfoMessage(container, config) {
        let infoDiv = container.querySelector(`.${config.infoDivClass}`);

        if (!infoDiv) {
            // Create the info div
            infoDiv = document.createElement('div');
            infoDiv.className = `pile-info-message ${config.infoDivClass}`;
            
            // Styling
            infoDiv.style.padding = '5px 0 10px 0';
            infoDiv.style.fontSize = '14px';
            infoDiv.style.fontWeight = '500';
            infoDiv.style.color = '#de6a27';
            infoDiv.style.cursor = 'pointer';
            infoDiv.style.textAlign = 'left';
            infoDiv.style.display = 'none'; // Default hidden
            infoDiv.style.textDecoration = 'none';
            infoDiv.style.marginBottom = '5px';
            
            infoDiv.textContent = config.text;

            // Open drawer on click
            infoDiv.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                config.openDrawerFn();
            });

            // Try to find the label or header to insert after it
            const label = container.querySelector('.pc-field-label, .pc-label, .pc-accordion-header, label');
            if (label) {
                label.parentNode.insertBefore(infoDiv, label.nextSibling);
            } else {
                // If no label, just prepend it to the container
                container.insertBefore(infoDiv, container.firstChild);
            }
        }

        // Check if open
        const header = container.querySelector('.pc-accordion-header');
        // If it doesn't have an accordion header, just show it
        if (!header) {
            infoDiv.style.display = 'block';
            return;
        }

        const isOpen = header.classList.contains('open') && header.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
            infoDiv.style.display = 'block';
        } else {
            infoDiv.style.display = 'none';
        }
    }

    function initContainers() {
        configs.forEach(config => {
            const selectorStr = config.selectors.join(', ');
            const containers = document.querySelectorAll(selectorStr);
            
            containers.forEach(container => {
                if (!container.dataset.drawerInjectorInit) {
                    container.dataset.drawerInjectorInit = "true";
                    
                    // Initial update
                    updateInfoMessage(container, config);

                    // Observe container for changes to the header
                    const observer = new MutationObserver(() => {
                        updateInfoMessage(container, config);
                    });

                    observer.observe(container, { 
                        attributes: true, 
                        childList: true, 
                        subtree: true,
                        attributeFilter: ['class', 'aria-expanded']
                    });
                } else {
                    // Update in case it needs to be refreshed
                    updateInfoMessage(container, config);
                }
            });
        });
    }

    function init() {
        initContainers();
        
        // Continuous observer to catch dynamically injected forms/accordions
        const bodyObserver = new MutationObserver(() => {
            initContainers();
        });
        bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
